import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import Categories from "./components/Categories";
import HotList from "./components/HotList";
import NewUpdates from "./components/NewUpdates";
import EditorPicks from "./components/EditorPicks";
import Stories from "./components/Stories";
import Faq from "./components/Faq";
import AboutContact from "./components/AboutContact";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Categories />
        <HotList />
        <NewUpdates />
        <EditorPicks />
        <Stories />
        <Faq />
        <AboutContact />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}